/**
 * Die aufklappbare Zoll-Stufe einer Zeitstrahl-Zeile.
 *
 * OHNE VORBILD IM ORIGINAL: der Bestand kennt nur die Transportstufe „Zoll" als einen von sechs
 * Punkten ohne Innenleben. Verhaltensaenderung 6 haengt daran die vier Zeitstempel der
 * Zollabwicklung. Die Flaeche ist deshalb Teil des Ausnahmeregisters (`test/visual/ausnahmen.ts`,
 * Eintrag `TimelinePage`) und wird ausschliesslich hier und im Komponententest belegt, nicht ueber
 * die Screenshot-Baseline.
 *
 * Die vier Stufen stehen IMMER alle vier da, auch die noch nicht erfolgten (dann `—`). Eine Liste,
 * die nur das Erreichte zeigt, beantwortet die eigentliche Frage nicht - naemlich woran es gerade
 * haengt.
 */
import { useState } from "react";
import { fmtDT } from "../../lib/format.ts";
import type { Sendungszoll } from "../../lib/types.ts";

/** Die vier Schritte der Zollabwicklung in ihrer fachlichen Reihenfolge. */
export const ZOLL_STUFEN: readonly { feld: keyof Sendungszoll; label: string }[] = [
  { feld: "uebermittelt", label: "übermittelt" },
  { feld: "angenommen", label: "angenommen" },
  { feld: "freigegeben", label: "freigegeben" },
  { feld: "abgabenBezahlt", label: "Abgaben bezahlt" },
];

export interface ZollStufeProps {
  zoll: Sendungszoll;
}

export function ZollStufe({ zoll }: ZollStufeProps) {
  const [offen, setOffen] = useState(false);
  return (
    <div className="tlp-zoll">
      <button
        type="button"
        className="tlp-zoll-schalter"
        aria-expanded={offen}
        onClick={(ereignis) => {
          // Die Zeile darunter oeffnet den Drawer (`index.html:13787`). Ohne diesen Halt oeffnete
          // jedes Aufklappen zugleich die Bestellung.
          ereignis.stopPropagation();
          // Reload-Bug: der Knopf steckt in einem echten `<a href>` (`Verweis`/react-router
          // `Link`, `ZeitstrahlSeite.tsx`). `stopPropagation()` allein haelt nur React-Handler
          // weiter oben in der Kette auf - NICHT die native Default-Aktion des Ankers (Navigation
          // ueber `href`), die an `event.defaultPrevented` haengt, nicht an Propagation. Ohne
          // `preventDefault()` navigiert der Browser hier nativ -> voller Seiten-Reload statt
          // dass sich die Zoll-Stufe aufklappt.
          ereignis.preventDefault();
          setOffen((vorher) => !vorher);
        }}
      >
        Zoll
      </button>
      {offen ? (
        <ul className="tlp-zoll-stufen">
          {ZOLL_STUFEN.map(({ feld, label }) => {
            const wert = zoll?.[feld];
            return (
              <li className={`tlp-zoll-stufe ${wert ? "erfolgt" : "offen"}`} key={String(feld)}>
                {label}: {wert ? fmtDT(wert as string) : "—"}
              </li>
            );
          })}
        </ul>
      ) : null}
    </div>
  );
}
